// extracted by mini-css-extract-plugin
export default {"emoji-container":"style_emoji-container__hn6MG","emoji":"style_emoji__-Bq53","reaction-emoji":"style_reaction-emoji__-GnD8"};